import React from 'react';
import InformationCard from '../InformationCard';
import { colors, Typography } from 'kangarootime-ui';
import Event from './Event';

const TodaysEvents = ({ isLoading, events }) => {
  return (
    <InformationCard
      showExpandButton={false}
      title='Events'
      color={colors.cerulean}
      isLoading={isLoading}
    >
      { events.length > 0
        ? events.map((event, index) => <Event event={event} key={index} />)
        : <Typography style={{ fontSize: '0.875rem', lineHeight: 'normal', color: '#5F5F5F' }}>No events scheduled today</Typography>
      }
    </InformationCard>
  );
};

export default TodaysEvents;
